import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { Box, createTheme, ThemeProvider, Typography } from "@mui/material";
import ReservationsContainer from "../../Components/reservations/ReservationsContainer";
import { useRetrieveCompany } from "../../hooks/useRetrieveCompany";
import { useClientSubscriptionExpired } from "../../hooks/useClientSubscriptionExpired";
import { ClientReservationContext } from "../../context/ClientReservationProvider";
import useIsMobile from "../../hooks/useIsMobile";
import LoadingSpinner from "../../Components/loadingSpinner/LoadingSpinner";
import CompanyLogo from "../../Components/companyLogo/CompanyLogo";
import CompanyUnavailable from "../../Components/companyUnavailable/CompanyUnavailable";

const theme = createTheme({
  typography: {
    fontFamily: "inherit",
  },
});

const Home = () => {
  const isMobile = useIsMobile();
  const { dynamicPath } = useParams();
  const { company } = useContext(ClientReservationContext) || {};
  const { primaryColor, secondaryColor, id, name } = company || {};
  useRetrieveCompany();
  const { isExpired, subscriptionInfo, loading } =
    useClientSubscriptionExpired(dynamicPath);

  const isPrimaryColorWhite = primaryColor === "#FFFFFF";

  if (loading || !company) {
    return (
      <Box
        minHeight={{ xs: "80vh", md: "100vh" }}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <LoadingSpinner />
      </Box>
    );
  }

  if (isExpired && subscriptionInfo && subscriptionInfo.subscription) {
    return <CompanyUnavailable />;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
      minHeight={{ xs: "80vh", md: "100vh" }}
      overflow="hidden"
    >
      <Box
        flexGrow={1}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <CompanyLogo
          companyId={id}
          companyName={name}
          width={isMobile ? "220px" : "250px"}
          height={isMobile ? "220px" : "250px"}
        />
        <ThemeProvider theme={theme}>
          <Typography
            sx={{ fontWeight: 700, letterSpacing: "0.2" }}
            fontSize="28px"
            color={isPrimaryColorWhite ? secondaryColor : primaryColor}
          >
            {company?.name}
          </Typography>
        </ThemeProvider>
        <ReservationsContainer
          primaryColor={primaryColor || ""}
          secondaryColor={secondaryColor || ""}
        />
      </Box>

      <Box textAlign="center" paddingBottom={isMobile ? 0 : "30px"}>
        <Typography fontSize="12px" color="#22303E">
          Deseja nossa solução em sua empresa?
        </Typography>
        <Typography fontSize="12px" color="#22303E">
          Visite: www.anotareservas.com
        </Typography>
      </Box>
    </Box>
  );
};

export default Home;
